import {
    DELETE_PERMISSION_FROM_TEAM,
    DELETE_PERMISSION_FROM_TEAM_FAIL,
    DELETE_PERMISSION_FROM_TEAM_SUCCESS
} from './actionTypes';

const initialState = {
    teamId: null,
    permissionToBeDeleted: null,
    deletedPermission: null,
    error: null,
    loading: false,
    loaded: false
};

export function deleteTeamPermissionReducer(state = initialState, action) {
    switch (action.type) {
        case DELETE_PERMISSION_FROM_TEAM:
            return {
                ...initialState,
                teamId: action.payload.teamId,
                permissionToBeDeleted: action.payload.permission,
                loading: true
            };
        case DELETE_PERMISSION_FROM_TEAM_SUCCESS:
            return {
                ...state,
                deletedPermission: action.payload,
                loaded: true,
                loading: false
            };
        case DELETE_PERMISSION_FROM_TEAM_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
